import React from 'react';
import ConfigurableLink from 'swag-client-common/components/utils/configurable-link';
import { hasMyCompanyItem } from 'swag-client-common/utils/my-company.util';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classNames from 'classnames';
import classes from './account-dropdown.scss';
export const OtherLinks = ({
  userRole,
  useHardLinks,
  routeNavigationConfirmation,
  orderApprovalFlow = false,
  userIsHeadOfCompanyDepartment = false,
  inventoryId,
  showInventoryLink,
  isApiAccessEnabled
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, showInventoryLink && /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "MyInventory",
    isHardLink: !routeNavigationConfirmation,
    routeNavigationConfirmation: routeNavigationConfirmation,
    className: classNames(classes.dropdownItem, classes.inventoryItem),
    link: `/inventory/${inventoryId}`
  }, "My inventory"), /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "SizeSubmissions",
    className: classes.dropdownItem,
    link: APP_ROUTES.SIZE_SUBMISSIONS,
    isHardLink: useHardLinks,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, "Size submissions"), isApiAccessEnabled && /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "PublicAPI",
    isHardLink: !routeNavigationConfirmation,
    routeNavigationConfirmation: routeNavigationConfirmation,
    className: classes.dropdownItem,
    link: APP_ROUTES.ACCOUNT_PUBLIC_API
  }, "Public API"), hasMyCompanyItem({
    userRole,
    userIsHeadOfCompanyDepartment,
    orderApprovalFlow
  }) && /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "MyCompany",
    className: classes.dropdownItem,
    link: APP_ROUTES.MY_COMPANY,
    isHardLink: useHardLinks,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, "My company"));
};